// BK does not have an initial picker aspect, we just use the normal
// picker aspect.
import PickerAspectOption from '.';

export default PickerAspectOption;
